<div>
  <div class="flex gap-2 p-4 items-center">
    <wun-config-icon/>
    <span class="text-xl font-bold">
      Dashboard
    </span>
  </div>
  <div>
    <div class="grid grid-cols-1 gap-3 p-4 md:grid-cols-2 lg:grid-cols-4">
      <div class="flex flex-col justify-between w-full p-4 border border-gray-400 border-solid">
        <div class="flex items-center justify-between">
          <div class="flex w-full justify-between">
            <h2 class="text-2xl font-bold">Utenti</h2>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                 fill="none" stroke-linecap="round" stroke-linejoin="round" class="w-10 stroke-cyan-500">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
        </div>
        <div class="p-4">
          <ul class="list-disc">
            <li class="text-sm">1 nuove registrazioni</li>
            <li class="text-sm">0 nuove opere caricate</li>
          </ul>
        </div>
        <a wunButton primary routerLink="./users" class="shrink-0">Vai e modifica</a>
      </div>
      <div class="flex flex-col justify-between w-full p-4 border border-gray-400 border-solid">
        <div class="flex items-center justify-between">
          <div class="flex justify-between w-full">
            <h2 class="text-2xl font-bold">Editoriale</h2>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                 fill="none" stroke-linecap="round" stroke-linejoin="round" class="w-10 stroke-cyan-500">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <rect x="4" y="4" width="6" height="5" rx="2"></rect>
              <rect x="4" y="13" width="6" height="7" rx="2"></rect>
              <rect x="14" y="4" width="6" height="16" rx="2"></rect>
            </svg>
          </div>
        </div>
        <div class="p-4">
          <ul class="list-disc ">
            <li class="text-sm">2 slides</li>
            <li class="text-sm">0 mostre</li>
          </ul>
        </div>
        <a wunButton primary routerLink="./editorials" class="shrink-0">Vai e modifica</a>
      </div>
      <div class="flex flex-col justify-between w-full p-4 border border-gray-400 border-solid">
        <div class="flex items-center justify-between">
          <div class="flex justify-between w-full">
            <h2 class="text-2xl font-bold">Blog</h2>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                 fill="none" stroke-linecap="round" stroke-linejoin="round" class="w-10 stroke-cyan-500">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11"></path>
              <line x1="8" y1="8" x2="12" y2="8"></line>
              <line x1="8" y1="12" x2="12" y2="12"></line>
              <line x1="8" y1="16" x2="12" y2="16"></line>
            </svg>
          </div>
        </div>
        <div class="p-4">
          <ul class="list-disc ">
            <li class="text-sm">0 bozze di articoli</li>
            <li class="text-sm">1 articoli pubblicati</li>
          </ul>
        </div>
        <a wunButton primary routerLink="./blogs" class="shrink-0">Vai e modifica</a>
      </div>
      <div class="flex flex-col justify-between w-full p-4 border border-gray-400 border-solid">
        <div class="flex items-center justify-between">
          <div class="flex w-full justify-between">
            <h2 class="text-2xl font-bold">Messaggi</h2>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-10 stroke-cyan-500">
              <path
                d="M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm32 352c0 17.6-14.4 32-32 32H293.3l-8.5 6.4L192 460v-76H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32v288zM280 240H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm96-96H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8z"></path>
            </svg>

          </div>
        </div>
        <div class="p-4">
          <ul class="list-disc ">
            <li class="text-sm">1 nuovi messaggi dal cliente</li>
            <li class="text-sm">0 nuovi messaggi dall'artista</li>
          </ul>
        </div>
        <a wunButton primary routerLink="./messages" class="shrink-0">Vai e modifica</a>
      </div>
    </div>
  </div>
</div>
